import {List} from 'immutable';
import moment from 'moment-timezone';

import {PricingType} from 'web-app/react/entities/common/pricing';
import {hasValue} from 'web-app/util/typescript';

// Pricing with volume 1 is guaranteed for all available age groups since that is how a sessions is currently created
export const getFilteredSessionPricing = session => session.pricing.filter(pricing => pricing.volume === 1);

const isAllPricingGroupsSame = (filteredSessionPricing, volumeOnePricing) =>
    filteredSessionPricing.every(sessionPricing => {
        const pricingGroupPricing = volumeOnePricing.find(
            volumePricing => volumePricing.pricingGroupId === sessionPricing.pricingGroupId,
        );
        return (
            pricingGroupPricing &&
            sessionPricing.pricing !== PricingType.HOURLY &&
            pricingGroupPricing.pricing === sessionPricing.pricing
        );
    });

const isSessionValid = (session, volumeOnePricing) => {
    const filteredSessionPricing = getFilteredSessionPricing(session);
    return (
        volumeOnePricing.size === filteredSessionPricing.size &&
        isAllPricingGroupsSame(filteredSessionPricing, volumeOnePricing)
    );
};

export const getSessionIdsWithoutPrice = (volumeOnePricing, sessions) =>
    sessions.filter(session => !isSessionValid(session, volumeOnePricing)).map(s => s.sessionId);

export const getLatestValidFrom = sessions => {
    const validFromList = List(sessions)
        .map(session => session.validFrom)
        .filter(hasValue)
        // Make sure there is always a moment in the list, or moment.max returns moment()
        .push(moment(0))
        .toArray();
    return moment.max(validFromList);
};

export const convertGroupToAPI = group => {
    if (group.sessions && group.pricingGroups) {
        const sessionIds = group.sessions.map(s => s.sessionId);

        const pricing = List(group.pricingGroups)
            .flatMap(pricingGroup => {
                return pricingGroup.sessionPricing
                    .map((sp, i) =>
                        sp && sp.sessionPrice
                            ? {
                                  pricingGroupId: pricingGroup.pricingGroupId,
                                  price: sp.sessionPrice,
                                  adhocPrice: sp.adhocPrice ? sp.adhocPrice : null,
                                  pricing: pricingGroup.pricing,
                                  volume: i + 1,
                              }
                            : null,
                    )
                    .filter(sp => sp);
            })
            .toJS();

        const apiGroup = {
            validFrom: group.validFrom,
            sessionIds,
            pricing,
        };

        if (group.volumeDiscountGroupId) {
            apiGroup.volumeDiscountGroupId = group.volumeDiscountGroupId;
        }

        return apiGroup;
    }

    return null;
};
